import { Alert, Input } from '@/shared/ui';
import { OtcFormFieldsProps } from './types';

export const IncludedInMedBoxInputs = ({ values, errors, touched, setFieldValue, setErrors, handleBlur }: OtcFormFieldsProps) => (
    <>
        <div className='bg-mint-200 flex flex-col rounded-[0.8125rem] p-5 md:p-7.5'>
            <p data-testid="otc-medication-form-content-title" className="font-bold atkinsonHyperlegible text-17 md:text-21 mb-4">
                How many times per day do you take this medication or supplement?
            </p>
            <Input
                label={"Times Per Day"}
                name="quantity"
                required
                type='text'
                placeholder="ex. 3"
                value={values.quantity}
                onChange={(e) => {
                    const rawValue = e.target.value;
                    let sanitizedValue = rawValue.replace(/[^0-9]/g, '');
                    sanitizedValue = sanitizedValue.replace(/^0+/, '');
                    setFieldValue('quantity', !sanitizedValue || sanitizedValue === '0' ? null : sanitizedValue);
                    setErrors({});
                }}
                onBlur={handleBlur}
                error={!!errors.quantity && !!touched.quantity}
                sx={errors.quantity && touched.quantity ? {
                    "&.Mui-disabled": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "red" } }
                } : {}}
                labelClassName={`${errors.quantity && touched.quantity ? 'text-red-500' : ''} !text-18 sm:!text-21`}
                testId="register-form-create-password"
                enableNaturalEnter
            />
            {errors.quantity && touched.quantity && <Alert boldLabel={false} className='mt-[0.625rem]' label={errors.quantity} />}
        </div>
        <div className='bg-mint-200 flex flex-col rounded-[0.8125rem] p-5 md:p-7.5'>
            <p className="font-bold atkinsonHyperlegible text-17 md:text-21 mb-4">
                How many tablets or capsules do you take per dose?
            </p>
            <Input
                label={"Tablets per dose"}
                name="tabletsPerDose"
                type='text'
                required
                placeholder="ex. 2"
                value={values.tabletsPerDose}
                onChange={(e) => {
                    const rawValue = e.target.value;
                    let sanitizedValue = rawValue.replace(/[^0-9]/g, '');
                    sanitizedValue = sanitizedValue.replace(/^0+/, '');
                    setFieldValue('tabletsPerDose', !sanitizedValue || sanitizedValue === '0' ? null : sanitizedValue);
                    setErrors({});
                }}
                onBlur={handleBlur}
                error={!!errors.tabletsPerDose && !!touched.tabletsPerDose}
                sx={errors.tabletsPerDose && touched.tabletsPerDose ? {
                    "&.Mui-disabled": { "& .MuiOutlinedInput-notchedOutline": { borderColor: "red" } }
                } : {}}
                labelClassName={`${errors.tabletsPerDose && touched.tabletsPerDose ? 'text-red-500' : ''} !text-18 sm:!text-21`}
                testId="register-form-tablets-per-dose"
                enableNaturalEnter
            />
            {errors.tabletsPerDose && touched.tabletsPerDose && <Alert className='mt-[0.625rem]' label={errors.tabletsPerDose} boldLabel={false} />}
        </div>
    </>
);
